
/**
 * アコーディオンアニメーション
 */
export class Accordion {
  /**
   * 対象の要素オブジェクト
   */
  private readonly $element: JQuery;

  /**
   * アニメーション時間（ミリ秒）
   */
  private readonly animationTime: number;

  /**
   * コンストラクタ
   * @param element 対象の要素セレクタ
   * @param delay 遅延時間（ミリ秒）
   */
  constructor(element: string, delay: number) {
    this.$element = $(element);
    this.animationTime = delay;
    this.init();
  }

  /**
   * 初期化
   */
  private init(): void {
    this.Accordion();
  }

  /**
   * アコーディオンアニメーション
   */
  private Accordion(): void {
    this.$element.on("click", function() {
      $(this).toggleClass("is-shown");
      $(this).next().toggleClass("is-shown");
    });
  }
}
